export const Bio = {
    name: "Deepak Reddy",
    roles: [
      "Full Stack Developer",
      "Android Developer",
      "UI/UX Designer",
      "Programmer",
    ],
    description:
      "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/deepakreddygit",
    resume:
      "https://drive.google.com/file/d/1DrVrpWjfIYaZtAPJBCIQr8XAIN3dey8c/view?usp=sharing",
    linkedin: "https://www.linkedin.com/in/deepakreddy16/",
    twitter: "https://twitter.com/Dpk_Rdy",
    insta: "https://www.instagram.com/d.e.e.p.a.k.0.3/",
    medium: "https://medium.com/@deepakreddy1635",
    leetcode: "https://leetcode.com/u/SSDeepakReddy/"

  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "Angular",
          image:
            "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/icons%2Fangular.png?alt=media&token=55475356-a7be-4e2b-a1ac-9334eeb4e3b8",
        },
        {
          name: "Redux",
          image:
            "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
        },
        {
          name: "Next Js",
          image:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
        },
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
        {
          name: "Material UI",
          image:
            "data:image/png;base64,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",
        },
        {
          name: "Flutter",
          image:
            "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
        },
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Node Js",
          image: "https://nodejs.org/static/images/logo.svg",
        },
        {
          name: "Express Js",
          image:
            "data:image/png;base64,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",
        },
        {
          name: "Graph Ql",
          image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
        },
        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "Postgresql",
          image: "https://www.postgresql.org/media/img/about/press/elephant.png",
        },
        {
          name: "MongoDB",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        },
        {
          name: "Firebase",
          image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
        },
      ],
    },
    {
      title: "Android",
      skills: [
        {
          name: "Java",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        },
        {
          name: "Kotlin",
          image:
            "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
        },
        {
          name: "XML",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
        },
        {
          name: "Android Studio",
          image:
            "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
        },
      ],
    },
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/icons%2Fgiticon.png?alt=media&token=b30e3bc6-8c60-40b8-946f-96e4f700850c",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "Docker",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
        },
        {
          name: "Netlify",
          image:
            "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
        },
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Postman",
          image:
            "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/icons%2Fpostmanicon.jpg?alt=media&token=1c469c76-929a-4085-bcf6-08a5111f96d7",
        },
        // {
        //   name: "Adobe XD",
        //   image:
        //     "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
        // },
        {
          name: "Figma",
          image:
            "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/icons%2Ffigmaicon.png?alt=media&token=88708d70-bf48-4c6a-a19a-4c89f45c138a",
        },
      ],
    },
  ];
  
  // export const experiences = [
  //   {
  //     id: 1,
  //     img: "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/EDUCATION%2FKSU.jpg?alt=media&token=ae7fad55-6b73-4317-b629-e7b74ea8756c",
  //     role: "Teaching Assistant",
  //     company: "Kent State University",
  //     date: "Jan 2025 - Present",
  //     desc: "Serving as a Teaching Assistant for Database and Human-Computer Interaction courses. Responsibilities include conducting lab sessions, assisting students with coursework, clarifying concepts, invigilating exams, grading assignments, and providing academic support to enhance student learning outcomes.",
  //     skills: [
  //       "Database Systems",
  //       "SQL",
  //       "MongoDB",
  //       "Human-Computer Interaction",
  //       "UI/UX Principles",
  //       "Teaching & Mentoring",
  //       "Grading & Evaluation",
  //       "Classroom Management"
  //     ],
  //     doc: "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/EXPERIENCE%2FTAoffer.png?alt=media&token=e3a225f6-c91a-470b-bbc1-59c5737d6a0f",
  //   },
  //   {
  //     id: 0,
  //     img: "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/EXPERIENCE%2Feficens.png?alt=media&token=172ec9e1-3937-4a66-900b-4511ab0e82c5",
  //     role: "Frontend Developer Intern",
  //     company: "Eficens Software Services Private Limited",
  //     date: "March 2022 - May 2023",
  //     desc: "Working on the frontend of the web application using Angular 14, Redux, and Material UI.",
  //     skills: [
  //       "Angular 14",
  //       "Redux",
  //       "NodeJs",
  //       "Angular Material UI",
  //       "HTML",
  //       "CSS",
  //       "JavaScript",
  //     ],
  //     doc: "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/EXPERIENCE%2FScreenshot%202024-12-04%20at%2012.14.21%E2%80%AFPM.png?alt=media&token=838e5d92-aa92-42b1-ac9f-1bdd02b376c9",
  //   },
    
  export const experiences = [
    {
      id: 2,
      img: "https://upload.wikimedia.org/wikipedia/commons/b/b3/Wells_Fargo_Bank.svg",
      role: "Full Stack Developer",
      company: "Wells Fargo",
      date: "May 2025 - Present | USA",
      desc: "Developing and maintaining scalable enterprise web applications using Java, Spring Boot, and Angular. Collaborating with cross-functional teams to deliver high-quality features, optimize performance, and improve user experience across banking platforms.",
      skills: [
        "Java",
        "Spring Boot",
        "Angular",
        "REST APIs",
        "SQL",
        "Database Optimization",
        "Automated Testing",
        "Agile/Scrum",
        "Code Reviews",
        "UI/UX Enhancement"
      ],
      doc: "",
    },
  
    {
      id: 1,
      img: "https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg",
      role: "Full Stack Developer",
      company: "IBM",
      date: "Mar 2021 - Dec 2023 | India",
      desc: "Designed and developed enterprise-grade full-stack applications using Java, Angular, Node.js, and REST APIs. Worked extensively on backend services, cloud deployments, performance tuning, and responsive UI components in Agile environments.",
      skills: [
        "Java",
        "Angular",
        "Node.js",
        "REST APIs",
        "AWS (EC2, S3, Lambda)",
        "SQL",
        "Performance Tuning",
        "Agile/Scrum",
        "Application Monitoring",
        "Responsive UI Development"
      ],
      doc: "",
    },
  
    {
      id: 0,
      img: "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/EDUCATION%2FKSU.jpg?alt=media&token=ae7fad55-6b73-4317-b629-e7b74ea8756c",
      role: "Teaching Assistant",
      company: "Kent State University",
      date: "Jan 2025 - Dec 2025",
      desc: "Serving as a Teaching Assistant for Database Systems and Human-Computer Interaction courses. Conduct lab sessions, assist students with SQL and database concepts, grade assignments, invigilate exams, and provide academic mentoring.",
      skills: [
        "Database Systems",
        "SQL",
        "MongoDB",
        "Human-Computer Interaction",
        "UI/UX Principles",
        "Teaching & Mentoring",
        "Grading & Evaluation"
      ],
      // doc: "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/EXPERIENCE%2FTAoffer.png?alt=media",
    }
  ];
  
  export const education = [
    {
      id: 0,
      img: "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/EDUCATION%2FKSU.jpg?alt=media&token=ae7fad55-6b73-4317-b629-e7b74ea8756c",
      school: "Kent State University",
      date: "Spring 2024 - Present",
      grade: "3.95/4.0",
      desc: "I am currently pursuing my Master's degree in Computer Science at Kent State University. My coursework includes advanced topics in machine learning, data science, and software engineering.",
      degree: "Master of Science - MS, Computer Science",
    },
    {
      id: 1,
      img: "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/EDUCATION%2FSITE.jpeg?alt=media&token=8f245605-d7d5-435c-b413-8f43461fe675",
      school: "Sasi Institute of Technology and Engineering",
      date: "Aug 2019 - May 2023",
      grade: "8.59/10",
      desc: "I completed my Bachelor's degree in Computer Science and Engineering at Sasi Institute of Technology and Engineering, Tadepalligudem. My four-year tenure at SITE was an exciting exploration of the world of technology and engineering. I consistently demonstrated my dedication to learning and achieved an impressive CGPA of 8.59. SITE provided a nurturing environment that fueled my passion for innovation and prepared me for the dynamic challenges of the tech industry.",
      degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
    },
    {
      id: 2,
      img: "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/EDUCATION%2Fsite_12.png?alt=media&token=de3d3d69-8d71-4092-b126-44508b308702",
      school: "Sasi Junior College, Tanuku",
      date: "Aug 2017 - Apr 2019",
      grade: "10/10",
      desc: "I completed my class 12 high school education at Sasi Junior College, Tanuku, where I studied Science with Computer Science.",
      degree: "BIE(XII), Science with Computer",
    },
    {
      id: 3,
      img: "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/EDUCATION%2Fmontessori.jpeg?alt=media&token=31bfcdf1-8d7c-4540-8399-91aef8ed2bb1",
      school: "Montessori School, Tanuku",
      date: "Apr 2017",
      grade: "10/10",
      desc: "I completed my class 10 education at Montessori School, Tanuku, where I studied Science with Computer Application.",
      degree: "SSC(X), Science with Computer",
    },
  ];
  
  
  export const projects = [
     //capstone project
     {
      id: 11,
      title: "Resume Builder App",
      date: "Jan 2025",
      description:
        "A full-stack resume builder web application built as our Capstone Project. It allows users to create and manage resumes with customizable templates, a progress tracker, and the ability to store previously entered data. The platform supports media uploads, user reviews on templates, and provides a seamless resume-building experience.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/PROJECTS%2Fresumebuilder.png?alt=media&token=9776bd29-08c3-4832-a7e8-036418006a31",
      tags: [
        "React.js",
        "HTML",
        "CSS",
        "Bootstrap",
        "Flask",
        "MongoDB Atlas",
        "Media Explorer"
      ],
      category: "web app",
      github: "https://github.com/deepakreddygit", 
      webapp: "https://theresumebuilderapp.netlify.app/",
      member: [
        {
          name: "Deepak Reddy",
          img: "https://avatars.githubusercontent.com/u/84923397?s=400&u=9bb949ab3893058e5a0642b9c847030857bb5bee&v=4",
          linkedin: "https://www.linkedin.com/in/deepakreddy16/",
          github: "https://github.com/deepakreddygit",
        },
        {
          name: "Meenakshi Menchu",
          img: "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/user%2Fuser.jpg?alt=media&token=faa32443-08fc-4b41-b6e7-4ed944f610f9",
          linkedin: "https://www.linkedin.com/in/meenakshi-menchu-a91527227/",
          github: "https://github.com/meenakshimenchu"
        },
        {
          name: "Siva Macharla Vimjam",
          img: "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/user%2Fuser.jpg?alt=media&token=faa32443-08fc-4b41-b6e7-4ed944f610f9",
          linkedin: "https://www.linkedin.com/in/siva-macharla-vimjam-27a123231/",
          github: "https://github.com/sivamacharla"
        },
      ],
    },
    {
      id: 12,
      title: "QuickInsights",
      date: "Aug 2024",
      description:
        "QuickInsights is a data exploration and analysis copilot that allows users to securely upload datasets (CSV/Excel) and interact with them through an intuitive dashboard. It provides instant visualizations, insights, and summaries powered by AI/LLMs. Built with React for the frontend and Flask for the backend, the platform supports authentication, data storage, and smooth interaction workflows.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/PROJECTS%2Fcopilot.png?alt=media&token=fab509b5-1ba9-49ab-b64b-928ed071e5b7",
      tags: [
        "React.js",
        "TS",
        "Flask",
        "Python",
        "MongoDB",
        "LLM",
        "Data Visualization"
      ],
      category: "machine learning",
      github: "https://github.com/deepakreddygit", 
      webapp: "https://quickinsights-data.netlify.app/",
      member: [
        {
          name: "Deepak Reddy",
          img: "https://avatars.githubusercontent.com/u/84923397?s=400&u=9bb949ab3893058e5a0642b9c847030857bb5bee&v=4",
          linkedin: "https://www.linkedin.com/in/deepakreddy16/",
          github: "https://github.com/deepakreddygit",
        },
      ],
    },
    
    {
      id: 9,
      title: "CEGMA",
      date: "August 2022 - May 2023",
      description:
        "CEGMA is a culmination of sensors, software and analytics. This full stack Industrial IoT platform enables you to prevent electrical failures, unplanned downtimes and improve safety by enabling a pro-active, data driven culture in your organisation's Electrical operations",
      image:
        "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/PROJECTS%2Fthumbnail1.png?alt=media&token=227ab734-6a5c-4bef-9870-3a676ff39a39",
      tags: [
        "Docker",
        "AWS",
        "CI/CD",
        "Angular 14",
        "Cloud9",
        "Node Js",
        "Express Js",
        "Redux",
      ],
      category: "web app",
      webapp: "https://app.innvendt.com/signup",
      member: [
        {
          name: "Deepak Reddy",
          img: "https://avatars.githubusercontent.com/u/84923397?s=400&u=9bb949ab3893058e5a0642b9c847030857bb5bee&v=4",
          linkedin: "https://www.linkedin.com/in/deepakreddy16/",
          github: "https://github.com/deepakreddygit",
        }]
    },
  

    {
      id: 0,
      title: "YouTube Clone",
      date: "Jul 2024",
      description:
        "Developed a YouTube clone web application that dynamically displays real-time YouTube data. Leveraged YouTube APIs to fetch and present videos, ensuring users can watch and interact with content seamlessly. Designed a responsive user interface using React JS and CSS, providing a consistent and optimal viewing experience across all devices. Utilized React Router for smooth navigation within the application. Followed agile methodologies to improve team collaboration and project delivery. Deployed the application to a cloud platform for easy access and scalability.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/PROJECTS%2Fthumbnail2.png?alt=media&token=07645960-85ee-48ef-9fcd-ef6de4f607c7",
      tags: ["React Js", "YouTube API's", "JS", "Axios", "HTML5", "CSS" , "Vercel"],
      category: "web app",
      github: "https://github.com/deepakreddygit/youtube-clone",
      webapp: "https://youtube-clone-psi-navy.vercel.app/",
      member: [
        {
          name: "Deepak Reddy",
          img: "https://avatars.githubusercontent.com/u/84923397?s=400&u=9bb949ab3893058e5a0642b9c847030857bb5bee&v=4",
          linkedin: "https://www.linkedin.com/in/deepakreddy16/",
          github: "https://github.com/deepakreddygit",
        },
      ],
    },
    {
      id: 1,
      title: "Alien Wave",
      date: "Nov 2024",
      description:
        "Developed a space-themed shooter game, 'Alien Wave,' where players defend against waves of alien enemies. The game features dynamic enemy spawning, increasing difficulty levels, and milestone-based visual and gameplay effects. Built using HTML5, CSS, and JavaScript, the game is designed with responsive controls and engaging visuals, including glowing effects, starfield background, and a thrilling triple-bullet shooting mechanic. Utilized DOM manipulation for game logic and animations, making it an interactive, browser-friendly experience.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/PROJECTS%2Falienwave%20.png?alt=media&token=421cf7f6-1c4d-496e-bbfe-7bead8921dba",
      tags: ["HTML5", "CSS", "JS", "Game Development", "Canvas API", "Firebase"],
      category: "android app",
      github: "https://github.com/deepakreddygit/alien-wave",
      webapp: "https://alienwave.tiiny.site/",
      member: [
        {
          name: "Deepak Reddy",
          img: "https://avatars.githubusercontent.com/u/84923397?s=400&u=9bb949ab3893058e5a0642b9c847030857bb5bee&v=4",
          linkedin: "https://www.linkedin.com/in/deepakreddy16/",
          github: "https://github.com/deepakreddygit",
        },
      ],
    },
    {
      id: 2,
      title: "Data Visualization",
      date: "April 2024",
      description:
        "In this project, we utilized D3.js to implement brushing in the scatter plot, enabling users to select data points that dynamically update the bar chart and line chart. Hovering over a bubble in the scatter plot displays its value through a tooltip, also created with D3.js. Brushing on the scatter plot causes corresponding changes in the other two charts. This interactivity allows for a comprehensive analysis of the cars dataset.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/PROJECTS%2Fdata%20visualization.png?alt=media&token=1544dd6b-81c2-4e9d-bbe3-23b521a817ff",
      tags: ["D3", "Javascript", "HTML", "CSS", "Bootstarp", "Firebase"],
      category: "web app",
      github: "https://github.com/deepakreddygit/InformationVisualization",
      webapp: "https://web.cs.kent.edu/~ssatti/Project-3/project-3.html ",
      member: [
        {
          name: "Deepak Reddy",
          img: "https://avatars.githubusercontent.com/u/84923397?s=400&u=9bb949ab3893058e5a0642b9c847030857bb5bee&v=4",
          linkedin: "https://www.linkedin.com/in/deepakreddy16/",
          github: "https://github.com/deepakreddygit",
        },
        {
          name: "Manikanta Yadlapalli",
          img: "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/user%2Fuser.jpg?alt=media&token=faa32443-08fc-4b41-b6e7-4ed944f610f9",
          linkedin: "https://www.linkedin.com/in/manikanta-sai-yadlapalli-b77b782b6/",
        },
      ],
    },
    {
      id: 3,
      title: "Predictive Modeling and Data Visualization for Healthcare Datasets",
      date: "Oct 2024",
      description:
        "This project involves the evaluation of machine learning models on healthcare datasets, specifically the Breast Cancer and Cleveland Heart Disease datasets. It includes data preprocessing, feature scaling, model training using Logistic Regression, Decision Trees, Random Forests, and more. Additionally, advanced techniques like SMOTE for balancing the dataset and PCA for dimensionality reduction were applied. The project features comprehensive data visualizations including heatmaps and PCA plots, providing insights into the model performance and dataset characteristics.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/PROJECTS%2Fcancer_MLProject.png?alt=media&token=a4dbd30f-0069-487f-b58f-5ffac9a323a2",
      tags: ["Python", "Scikit-learn", "SMOTE", "PCA", "Data Visualization"],
      category: "machine learning",
      github: "https://github.com/deepakreddygit/Predictive-Modeling-Healthcare",
     // webapp: "",
     member: [
      {
        name: "Deepak Reddy",
        img: "https://avatars.githubusercontent.com/u/84923397?s=400&u=9bb949ab3893058e5a0642b9c847030857bb5bee&v=4",
        linkedin: "https://www.linkedin.com/in/deepakreddy16/",
        github: "https://github.com/deepakreddygit",
      },
    ],
    },
    // {
    //   id: 10,
    //   title: "Job Finding App",
    //   date: "Jun 2023 - Jul 2023",
    //   description:
    //     "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
    //   image:
    //     "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.pn",
    //   tags: ["React Native", "JavaScript", "Axios"],
    //   category: "android app",
    //   github: "https://github.com/rishavchanda/Job-finder-App",
    //   webapp: "https://github.com/rishavchanda/Job-finder-App",
    // },
    // {
    //   id: 4,
    //   title: "Whatsapp Clone",
    //   date: "Jul 2021",
    //   description:
    //     "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
    //   image:
    //     "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
    //   tags: ["React Js", "Firebase", "Firestore", "Node JS"],
    //   category: "web app",
    //   github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
    //   webapp: "https://whatsapp-clone-rishav.web.app",
    // },
    // {
    //   id: 5,
    //   title: "Todo Web App",
    //   date: "Jun 2021",
    //   description:
    //     " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
    //   image:
    //     "https://camo.githubusercontent.com/a328255ad96f861f57d25096d28018ab2656c689a1456b0d145764009bed2d1a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
    //   tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
    //   category: "web app",
    //   github: "https://github.com/rishavchanda/Todo-Web-App",
    //   webapp: "https://rishav-react-todo.netlify.app/",
    //   member: [
    //     {
    //       name: "Deepak Reddy",
    //       img: "https://avatars.githubusercontent.com/u/84923397?s=400&u=9bb949ab3893058e5a0642b9c847030857bb5bee&v=4",
    //       linkedin: "https://www.linkedin.com/in/deepakreddy16/",
    //       github: "https://github.com/deepakreddygit",
    //     },
    //   ],
    // },
    
    {
      id: 6,
      title: "Assignment Arcade",
      date: "Dec 2020",
      description:
        "A todo list app is a simple yet powerful organizational tool designed to help users manage their tasks, activities, and responsibilities efficiently. It allows users to create, track, and prioritize tasks in a digital format, enabling them to stay organized and focused on their daily or long-term goals.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/PROJECTS%2Fthumbnail7.png?alt=media&token=8b2a27c2-5f2b-41f8-958d-05834b46acf5",
      tags: ["HTML", "CSS", "Bootstrap", "JavaScript","Jquery"],
      category: "web app",
      github: "https://github.com/deepakreddygit/ToDo-List",
      webapp: "https://assignmentarcade.web.app",
      member: [
        {
          name: "Deepak Reddy",
          img: "https://avatars.githubusercontent.com/u/84923397?s=400&u=9bb949ab3893058e5a0642b9c847030857bb5bee&v=4",
          linkedin: "https://www.linkedin.com/in/deepakreddy16/",
          github: "https://github.com/deepakreddygit",
        },
      ],
    },
    {
      id: 7,
      title: "User Management System (CRUD)",
      date: "Sept 2023",
      description:
        "Discovered a dynamic CRUD web application created using EJS, JavaScript, Node.js, and MongoDB. This versatile project incorporates AJAX, Axios, Mongoose, and Morgan for seamless data management. With an intuitive interface, it allows users to create, read, update, and delete records effortlessly. Explore the GitHub repository for an in-depth look.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/PROJECTS%2Fthumbnail5.png?alt=media&token=be931792-d094-4ba3-a8ee-a09f393d7d01",
      tags: ["Embedded JavaScript", "JavaScript", "Express", "MongoDB"],
      category: "web app",
      github: "https://github.com/deepakreddygit/crud_operations",
      webapp: "https://github.com/deepakreddygit/crud_operations",
      member: [
        {
          name: "Deepak Reddy",
          img: "https://avatars.githubusercontent.com/u/84923397?s=400&u=9bb949ab3893058e5a0642b9c847030857bb5bee&v=4",
          linkedin: "https://www.linkedin.com/in/deepakreddy16/",
          github: "https://github.com/deepakreddygit",
        },
      ],
    },
    {
      id: 8,
      title: "First Portfolio",
      date: "Jan 2021",
      description:
        "Developed a personal portfolio during my BTech using HTML, CSS, and JavaScript, and deployed it using Firebase. This project allowed me to explore advanced CSS animations to create engaging visual effects and enhance user experience. I implemented various JavaScript logics to add interactivity and dynamic features to the portfolio. The deployment on Firebase ensured smooth access and performance. This experience deepened my understanding of front-end development and cloud deployment.",
        image:
        "https://firebasestorage.googleapis.com/v0/b/portfolio-e5fe6.appspot.com/o/PROJECTS%2Fthumbnail9.png?alt=media&token=5de45f08-8d28-4dd5-ae4a-bc91debeb2d2",
      tags: ["HTML", "CSS", "JavaScript","Firebase"],
      category: "web app",
      github: "https://github.com/deepakreddygit/MyPortfolio",
      webapp: "https://deepakreddy.web.app/",
      member: [
        {
          name: "Deepak Reddy",
          img: "https://avatars.githubusercontent.com/u/84923397?s=400&u=9bb949ab3893058e5a0642b9c847030857bb5bee&v=4",
          linkedin: "https://www.linkedin.com/in/deepakreddy16/",
          github: "https://github.com/deepakreddygit",
        },
      ],
    },
   
    
  ];
  
  export const TimeLineData = [
    { year: 2017, text: "Started my journey" },
    { year: 2018, text: "Worked as a freelance developer" },
    { year: 2019, text: "Founded JavaScript Mastery" },
    { year: 2020, text: "Shared my projects with the world" },
    { year: 2021, text: "Started my own platform" },
  ];